import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import styles from 'styles/jss/original/components/favorites/favoriteMenuList';
import dummyImage from 'public/img/ui/loading-dummy.gif';
import FavoriteMenuListItemContainer from '@/containers/favorites/FavoriteMenuListItemContainer';
import MenuModal from '@/components/favorites/FavoriteMenuModal';
import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import Button from '@/components/common/ui/Button';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menuList: IMenu[];
  isLoading: boolean;
};

const FavoriteMenuList: React.FC<ComponentProps> = ({ menuList, isLoading }) => {
  const classes = useStyles();
  const [classicModal, setClassicModal] = useState(false);
  const renderContent = () => {
    if (isLoading) {
      return (
        <p className={classes.textWrapper}>
          <img src={dummyImage} alt='ローディング中' className={classes.imgLoading} />
        </p>
      );
    } else if (!isLoading && menuList.length === 0) {
      return <p className={classes.textWrapper}>献立をお気に入り登録しましょう</p>;
    } else {
      return (
        <>
          <div className={classes.shoppingList}>
            <Button color='warning' simple onClick={() => setClassicModal(true)}>
              <FormatListBulleted />
              買い物リストを見る
            </Button>
          </div>
          <GridContainer>
            {menuList.map((item, index) => {
              return (
                <FavoriteMenuListItemContainer
                  menu={item}
                  key={`favorite-item-${index.toString()}`}
                />
              );
            })}
          </GridContainer>
          <MenuModal
            menuList={menuList}
            isOpen={classicModal}
            onClose={() => setClassicModal(false)}
          />
        </>
      );
    }
  };

  return <div className={classes.section}>{renderContent()}</div>;
};

export default FavoriteMenuList;
